import type { ImageLoader, ImageProps } from 'next/image';

import { SBImageLoader } from '@utils/SBImageLoader';

export function getImageLoader(
  src: ImageProps['src'],
  aspectRatio?: number,
  focal?: string,
): ImageLoader | undefined {
  if (typeof src === 'string' && src.startsWith('https://a.storyblok.com')) {
    return SBImageLoader({ aspectRatio, focal });
  }
  return undefined;
}
